export const RELATADO_LIDER_OPTIONS = [
  { value: '1', label: 'Sim' },
  { value: '2', label: 'Nao' },
  { value: '3', label: 'Prefiro nao informar' },
  { value: '4', label: 'Nao sei quem e' },
];

export const STATUS_ATUAL_OPTIONS = [
  { value: '1', label: 'Em aberto' },
  { value: '2', label: 'Visto' },
  { value: '3', label: 'Em analise' },
  { value: '4', label: 'Em comite' },
  { value: '5', label: 'Finalizado' },
];

export const DESEJA_ACOMPANHAR_OPTIONS = [
  { value: 'true', label: 'Sim' },
  { value: 'false', label: 'Nao' },
];

export const formatDateTime = value => {
  if (!value) return '';

  return new Date(value).toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const buildOption = (value, label) => {
  if (value === undefined || value === null || value === '') {
    return null;
  }

  return {
    value: String(value),
    label: label || String(value),
  };
};

export const buildOptionsFromItems = (items = [], valueKey = 'id', labelKey = 'nome') =>
  items
    .filter(item => item && item[valueKey] !== undefined && item[valueKey] !== null)
    .map(item => ({
      value: String(item[valueKey]),
      label: item[labelKey] || String(item[valueKey]),
    }));

export const getOptionPrimitive = value => {
  if (value === undefined || value === null || value === '') {
    return undefined;
  }

  if (typeof value === 'object') {
    if (Array.isArray(value)) {
      return undefined;
    }

    if (value.value !== undefined) {
      return value.value;
    }
  }

  return value;
};

export const getOptionNumber = value => {
  const primitive = getOptionPrimitive(value);

  if (primitive === undefined || primitive === null || primitive === '') {
    return undefined;
  }

  const raw = String(primitive).trim();
  const directNumber = Number(raw);
  if (!Number.isNaN(directNumber)) {
    return directNumber;
  }

  const firstDigits = raw.match(/\d+/);
  if (!firstDigits) {
    return undefined;
  }

  const parsedDigits = Number(firstDigits[0]);
  return Number.isNaN(parsedDigits) ? undefined : parsedDigits;
};

export const getOptionBoolean = value => {
  const primitive = getOptionPrimitive(value);

  if (primitive === undefined || primitive === null || primitive === '') {
    return undefined;
  }

  if (typeof primitive === 'boolean') {
    return primitive;
  }

  const normalized = String(primitive).trim().toLowerCase();

  if (normalized === 'true') return true;
  if (normalized === 'false') return false;

  return undefined;
};

export const findOptionByValue = (value, options = []) => {
  if (value === undefined || value === null || value === '') {
    return null;
  }

  const rawValue = String(value).trim();
  const directMatch = options.find(
    option =>
      String(option.value).trim().toLowerCase() === rawValue.toLowerCase()
      || String(option.label).trim().toLowerCase() === rawValue.toLowerCase()
  );

  if (directMatch) {
    return directMatch;
  }

  const parsedNumber = getOptionNumber(value);
  if (parsedNumber !== undefined) {
    const numericMatch = options.find(option => Number(option.value) === parsedNumber);
    if (numericMatch) {
      return numericMatch;
    }
  }

  return buildOption(rawValue, rawValue);
};

export const formatBooleanLabel = value => {
  if (value === true) return 'Sim';
  if (value === false) return 'Nao';
  return '-';
};

export const formatTagsLabel = tags =>
  Array.isArray(tags) && tags.length > 0
    ? tags
        .map(tagItem => tagItem?.tag?.nomeTag || tagItem?.nomeTag || `Tag ${tagItem?.tagId || ''}`)
        .filter(Boolean)
        .join(', ')
    : '-';
